// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UrlUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as UtmConstants$PorterinFeature from "../constants/UtmConstants.mjs";

var utm_params_keys = [
  UtmConstants$PorterinFeature.utm_source,
  UtmConstants$PorterinFeature.utm_medium,
  UtmConstants$PorterinFeature.utm_campaign,
  UtmConstants$PorterinFeature.utm_term,
  UtmConstants$PorterinFeature.utm_content
];

function getUtmStringFromPath(path) {
  var urlParams = UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(path));
  var utm_source = Belt_Option.mapWithDefault(Js_dict.get(urlParams, UtmConstants$PorterinFeature.utm_source), "", (function (x) {
          return x;
        }));
  var utm_campaign = Belt_Option.mapWithDefault(Js_dict.get(urlParams, UtmConstants$PorterinFeature.utm_campaign), "", (function (x) {
          return x;
        }));
  return [
          utm_source,
          utm_campaign
        ];
}

function getUtmString(param) {
  var url = window.location.href;
  var urlParams = UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(url));
  var utm_source = Belt_Option.mapWithDefault(Js_dict.get(urlParams, UtmConstants$PorterinFeature.utm_source), "", (function (x) {
          return x;
        }));
  var utm_campaign = Belt_Option.mapWithDefault(Js_dict.get(urlParams, UtmConstants$PorterinFeature.utm_campaign), "", (function (x) {
          return x;
        }));
  return [
          utm_source,
          utm_campaign
        ];
}

export {
  utm_params_keys ,
  getUtmStringFromPath ,
  getUtmString ,
}
/* No side effect */
